import { useTranslation } from "react-i18next";
import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";

interface MyHrUserTwoFactorCardIsLockedProps {
  userData: {
    modifiedAt: string | number | Date;
    // add other userData properties if needed
  };
}

export const MyHrUserTwoFactorCardIsLocked = ({
  userData,
}: MyHrUserTwoFactorCardIsLockedProps) => {
  const { t } = useTranslation();
  const theme = useTheme();

  const lockedDate = new Date(userData?.modifiedAt).toLocaleDateString();

  return (
    <Box>
      <Box display="flex" flexDirection="row">
        <Box width="50%">
          <Typography variant="body1">
            {t("MY_HR_TWO_FACTOR_AUTHENTICATION")}:
          </Typography>
        </Box>
        <Box width="50%">
          <Typography variant="body1" color={theme.palette.primary.main}>
            {t("MY_HR_INACTIVE")}
          </Typography>
        </Box>
      </Box>
      <Box height="8px" />
      <Box display="flex" flexDirection="row">
        <Box width="50%">
          <Typography variant="body1" color={theme.palette.primary.main}>
            {t("MY_HR_USER_LOCKED")}:
          </Typography>
        </Box>
        <Box width="50%">{lockedDate}</Box>
      </Box>
      <Box sx={{ marginTop: "-4px" }}>
        <Typography variant="caption" sx={{ color: theme.palette.owGray.main }}>
          {t("MY_HR_AUTH_CODE_FAILED_THREE_TIMES")}
        </Typography>
      </Box>
    </Box>
  );
};

export default MyHrUserTwoFactorCardIsLocked;
